import React, { createContext, useContext, useMemo } from "react";
import { authFetch } from "../utils/authFetch";

// Контекст одного "админ-клиента"
const AdminApiCtx = createContext(() => Promise.resolve({ status: 0, data: null }));

export function AdminApiProvider({ children }) {
  const api = useMemo(() => {
    // Автопрефикс для админских URL
    const withPrefix = (url) => {
      if (url.startsWith("/api/")) return url;                 // уже абсолютный API
      if (url.startsWith("/")) return `/api/adminpanel${url}`; // "/admin/..." -> "/api/adminpanel/admin/..."
      return `/api/adminpanel/${url}`;                         // "admin/..." -> "/api/adminpanel/admin/..."
    };

    const fetcher = (url, opts = {}) => authFetch(withPrefix(url), opts);

    // Короткие формы
    fetcher.get  = (url, opts = {}) => fetcher(url, { ...opts, method: "GET" });
    fetcher.post = (url, body, opts = {}) =>
      fetcher(url, { ...opts, method: "POST", body: JSON.stringify(body) });

    // Для не-админских ручек (например /api/orders/statuses/)
    fetcher.raw = (url, opts = {}) => authFetch(url, opts);

    return fetcher;
  }, []);

  return <AdminApiCtx.Provider value={api}>{children}</AdminApiCtx.Provider>;
}

export const useAdminApi = () => useContext(AdminApiCtx);
